<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gnn35g/image/cover.jpg?1702297693093" alt="This image is the cover for the book Minding Miss Manners"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Minding Miss Manners
      </h1>
      <p class="bookDescription body article font2">
        <b>The etiquette expert and “authentic comic genius” guides us through the Age of Incivility (Chris Buckley, <i>New York Times</i>-bestselling author of <i>Has Anyone Seen My Toes</i>?).</b><br/>  <br/> We seem to be entering a new era, liberated from oppressive, old-fashioned rules of etiquette. We’re finally free! Free to shout insults at strangers on the street! Free to pressure people to give us money! Free to use all sorts of offensive language!<br/>  <br/> In this book, <i>New York Times</i>-bestselling author Judith Martin, aka Miss Manners, reminds us that living in an etiquette-free paradise is not all it’s cracked up to be. In wise, witty commentary and responses to letters, she addresses vexing problems in the workplace, at the wedding, on the web, and beyond, in hopes of saving civilization.<br/>  <br/> But fear not, Gentle Reader—she also allows us some important exceptions. For example, despite the rampant oversharing that social media has encouraged, you <i>can</i> politely refuse to answer nosy questions.  And you are decidedly <i>not</i> obliged to respond to every inane post; stay on the phone with a telemarketer; or hug your colleagues.<br/>  <br/> “An extremely useful philosopher . . . I consult her frequently, in order to behave better.” —Daniel Handler in <i>The</i><i>New York Times</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Judith Martin
      </h2>
      
      <p class="authorDescription body article">Judith Martin, aka Miss Manners, is a columnist, bestselling author of numerous books, and etiquette authority. Born a perfect lady in an imperfect society, Miss Manners is the pioneer mother of today’s civility movement. She lives in Washington D.C. and Venice, Italy.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d8518cb8